export default {
  init() {
    // Check Location Hash
    // Modal
    var hash = window.location.hash;

    if(hash){
      $(hash).trigger('click');
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/team.js